import ListItem from '../utils/ListItem';

function stripHtml(html) {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '').trim();
}

function AircraftListItem(props) {
  return (
    <ListItem
      to={props.link}
      primary={stripHtml(props.descr)}
      secondary={props.source}
    />
  );
}

export default AircraftListItem;
